@if (loading) {
  <div class="flex items-center justify-center py-10">
    <div class="loading loading-spinner loading-lg"></div>
  </div>
} @else if (loadError) {
  <div class="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
    {{ loadError }}
  </div>
} @else {
<div class="my-10">
  @if (event) {
    <h3 class="text-lg font-semibold">{{ event.name }}</h3>
    <p class="text-sm text-gray-600">Reminders</p>
  }
</div>

@if ((event.reminders || []).length > 0) {
  <!-- Card Layout (always shown for sidebar) -->
  <div class="space-y-4">
    @for (reminder of event.reminders; track reminder.id) {
      <div class="rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="flex items-start justify-between">
          <div class="flex-1 space-y-2">
            <div class="flex items-center gap-2 flex-wrap">
              <p class="text-theme-xs font-medium text-gray-500 dark:text-gray-400">Due:</p>
              <p class="text-theme-sm font-medium text-gray-700 dark:text-gray-300">
                {{ reminder.due_date | date: 'dd/MM/yyyy HH:mm' }}
              </p>
              <!-- Status Badge -->
              <span [class]="'inline-flex items-center px-2 py-1 text-xs font-medium rounded-md border ' + getStatusBadgeClass(reminder.status)">
                <lucide-icon [name]="getStatusIcon(reminder.status)" [size]="14" class="mr-1"></lucide-icon>
                {{ getStatusText(reminder.status) }}
              </span>
            </div>
            <div>
              <p class="text-theme-sm font-medium text-gray-900 dark:text-gray-100">
                {{ reminder.title }}
              </p>
            </div>
            @if (reminder.description) {
              <div>
                <p class="text-theme-sm text-gray-700 dark:text-gray-400 break-words">
                  {{ reminder.description }}
                </p>
              </div>
            }

            <!-- Status Details -->
            @if (reminder.status === 'sent' && reminder.sent_at) {
              <div class="text-xs text-green-700 dark:text-green-300">
                <span class="font-medium">Sent:</span> {{ reminder.sent_at | date: 'dd/MM/yyyy HH:mm' }}
              </div>
            }

            @if (reminder.status === 'failed') {
              <div class="text-xs text-red-700 dark:text-red-300 space-y-1">
                @if (reminder.failure_reason) {
                  <div><span class="font-medium">Error:</span> {{ reminder.failure_reason }}</div>
                }
                <div><span class="font-medium">Attempts:</span> {{ reminder.attempt_count }}</div>
                @if (reminder.next_attempt_at) {
                  <div><span class="font-medium">Next retry:</span> {{ reminder.next_attempt_at | date: 'dd/MM/yyyy HH:mm' }}</div>
                }
              </div>
            }
          </div>
          <div class="ml-4 shrink-0 flex gap-2">
            <button
              (click)="deleteReminder(reminder.id)"
              class="p-2 rounded-lg text-gray-500 hover:text-error-500 hover:bg-error-50 dark:text-gray-400 dark:hover:text-error-500 dark:hover:bg-error-500/10 transition-colors"
              title="Delete reminder">
              <lucide-icon [size]="16" [name]="TrashIcon"></lucide-icon>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}

@if (form) {
  <div class="flex items-center justify-between mt-10">
    <h3 class="text-lg font-semibold">Create reminder</h3>
  </div>

  <div class="-mx-2.5 mt-5 flex flex-wrap gap-y-5">
    <div class="w-full px-2.5 xl:w-1/2">
      <app-date-picker [control]="form.controls.due_date" [name]="'due_date'" [label]="'Date'"></app-date-picker>
    </div>
    <div class="w-full px-2.5 xl:w-1/2">
      <app-time-picker [control]="form.controls.due_time" [name]="'due_time'" [label]="'Time'"></app-time-picker>
    </div>
    <div class="w-full px-2.5">
      <app-text-input [control]="form.controls.title" [name]="'title'" [placeholder]="'Reminder title'"></app-text-input>
    </div>
    <div class="w-full px-2.5">
      <app-textarea [control]="form.controls.description" [name]="'reminder'" [placeholder]="'Reminder text'"></app-textarea>
    </div>
    <div class="w-full px-2.5">

      <div class="w-full mt-3 flex justify-end gap-3">
        <app-button [label]="'Cancel'" [disabled]="processing" [style]="'secondary'" (click)="cancel()"></app-button>
        <app-button [label]="'Save'" [disabled]="processing || !form.valid || isFormEmpty()" (click)="save()"></app-button>
      </div>
    </div>
  </div>
}

<app-modal
  [title]="'Delete Reminder'"
  [content]="getDeleteConfirmationMessage()"
  [show]="isDeleteModalOpen"
  [closeButtonLabel]="'Cancel'"
  [confirmButtonLabel]="'Delete'"
  (onClose)="cancelDelete()"
  (onConfirm)="confirmDelete()">
</app-modal>
}

